module.exports = __webpack_public_path__ + "media/images/yellow_half_circle_thick-59898d7a858edbf16093207fb5ab5141.svg";